// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2026":"1b750bc9","5670":"cd2f0e88","6320":"31d6cfe0","6897":"2b1fa926","7319":"804d0018","7432":"25d76421"}[chunkId] + ".chunk.css";
};